import { getLabel } from '../labels/labelling-service';
import logger from '../services/logging/logging-service';

const ADVERTISEMENT_LABEL_TEXT = getLabel('global.advertisement');
const ADVERTISEMENT_LABEL_CLASS = 'c-label--advertisement';

/**
 * Injects the advertisement label into the given node.
 * @param {HTMLElement} $advNode - The advertisement container node.
 */
const injectAdvLabel = ($advNode) => {
  const $labelNode = document.createElement('div');
  $labelNode.className = ADVERTISEMENT_LABEL_CLASS;
  const $labelText = document.createTextNode(ADVERTISEMENT_LABEL_TEXT);
  $labelNode.appendChild($labelText);
  // Append label as the first child
  $advNode.insertBefore($labelNode, $advNode.firstChild);
};

/**
 * Checks if the advertisement label already exists as a child of the given node.
 * @param {HTMLElement} $advNode - The advertisement container node.
 * @returns {boolean} - True if the label exists, false otherwise.
 */
const shouldInjectLabel = ($advNode) => {
  const hasLabel = $advNode.querySelector(`.${ADVERTISEMENT_LABEL_CLASS}`) !== null;
  return !hasLabel;
};

/**
 * Observes the advertisement containers and adds labels if necessary.
 */
export const initAdvLabels = () => {
  const $advNodes = document.querySelectorAll('.c-adv');
  $advNodes.forEach(($advNode) => {
    if (shouldInjectLabel($advNode)) {
      injectAdvLabel($advNode);
    }
  });
};
